<template>
    <div>
        
        <!-- 뷰 -->
        <post-view-mobile v-if="id" :id="id" :searchview="true" class="post_view"/>
        <div class="loading-spinner" v-if="!postlists.data">
            <base-spinner></base-spinner>
        </div>       
          
        <div  v-if="postlists.data">
            <post-list :postlists="postlists" :searchview="true" @scroll-to-top="scrollToTop"/>            
            <div class="paginate">                
                <paginate-public store="posts" collection="postsdata"  @paging="fetchLists" totalvisible="5" :isMobile="true"/>
            </div>
        </div>
    </div>
</template>
<script>
import { postSearch } from '@/components/mixins/pages/postSearch.js'
import PostList from '@/mobile/components/posts/PostList'
import PaginatePublic from '@/components/site/parts/PaginatePublic.vue';
export default { 
    name:'mobile_post_search',   
    mixins:[postSearch],
    components:{
        PostList,
        PaginatePublic
    },
    methods:{
        scrollToTop(){
            this.$emit('scroll-to-top');         
        }
    }
}
</script>
<style lang="scss" scoped>
.paginate{    
    background: #fff;
    padding:20px 0 200px 0;
}
</style>
